import { getEndpoint } from '../endpoints';
import { conformiteFields } from '../../utils/conformiteFields';
import { attachmentFields } from '../../utils/attachmentFields';

export const conformite = {
    state: {
        conformiteForm: {
            ...conformiteFields,
            ...attachmentFields,
        },
        preTreatmentEquipments: [],
        stormWaterStructure: [],
    },
    getters: {
        getConformiteForm(state) {
            return state.conformiteForm;
        },
        getPreTreatmentEquipments(state) {
            return state.preTreatmentEquipments;
        },
        getStormWaterStructure(state) {
            let references = [];
            var ref;
            state.stormWaterStructure.forEach(
                item => (
                    (ref = {
                        value: item.code,
                        name: item.internalLabel,
                    }),
                    references.push(ref)
                ),
            );
            return references;
        },
    },
    actions: {
        async getRequestConformiteById({ rootState, dispatch, commit }) {
            const { controlId: reqControlId, propertyId: reqPropertyId } = rootState.route.params;

            const controls = rootState.refControls.controls || [];
            const currentControlId = controls.length > 0 && controls[0].id ? controls[0].id : null;
            const currentPropertyId = rootState.refProperties && rootState.refProperties.property
                ? rootState.refProperties.property.id
                : null;

            const setControlData = function(controlsList, controlId) {
                if (!Array.isArray(controlsList) || controlsList.length === 0) {
                    return;
                }

                const control = controlsList.find(function(control) {
                    return control.id === controlId;
                });

                if (!control) {
                    return;
                }

                commit('setControl', control);

                const selections = control.data && control.data.gestionEpParcelleSelection;

                if (Array.isArray(selections)) {
                    control.data.gestionEpParcelleSelection = selections.map((item) => {
                        return {
                            value: item.id,
                            name: item.label,
                        };
                    });
                }

                commit('setConformiteForm', control.data);
            };

            const needToRefetch = reqControlId !== currentControlId || reqPropertyId !== currentPropertyId;

            if (needToRefetch) {
                await dispatch('fetchProperty', { id: reqPropertyId });
                await dispatch('setIdProperty', { id: reqPropertyId });
                await dispatch('fetchControls', { id: reqPropertyId });
            }

            setControlData(rootState.refControls.controls, reqControlId);
        },
        async fetchPreTreatmentEquipments({ rootState, commit }) {
            const endpoint = getEndpoint('referential').preTreatmentEquipments;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setPreTreatmentEquipments', data);
        },
        async fetchStormWaterStructure({ rootState, commit }) {
            const endpoint = getEndpoint('referential').stormWaterStructure;
            const { data } = await rootState.app.http.instance.get(endpoint);

            commit('setStormWaterStructure', data);
        },
        async submitConformite({ rootState, dispatch, commit, state }, payload) {
            let formData = new FormData();
            const endpoint = getEndpoint(rootState.app.typeForm, null, rootState.route.params.controlId)[
                payload.action
            ];

            commit('addExtratFieldsToFormConformite', { property: rootState.refProperties.property });

            // MultiSelect component
            if (state.conformiteForm.gestionEpParcelleSelection) {
                let valuesGestionEpParcellSelection = [];
                let gestionEpParcelleSelection = state.conformiteForm.gestionEpParcelleSelection;

                gestionEpParcelleSelection.forEach(item => valuesGestionEpParcellSelection.push(item.value));
                state.conformiteForm.gestionEpParcelleSelection = valuesGestionEpParcellSelection;
            }

            //Append files
            Object.entries(state.conformiteForm).map(([key, values]) => {
                //photos, sechma ...
                var exisitingFiles = [];
                if (Array.isArray(values)) {
                    values.forEach((fileElement, index) => {
                        if (fileElement instanceof File) {
                            formData.append(key + '[' + index + ']', fileElement);
                        } else if (fileElement) {
                            delete fileElement.manuallyAdded;
                            delete fileElement._removeLink;
                            exisitingFiles.push(fileElement);
                        }
                    });
                    state.conformiteForm[key] = exisitingFiles.slice();
                }
            });

            if (state.conformiteForm.signature && !state.conformiteForm.signature.startsWith('data:')) {
                state.conformiteForm.signature = null;
            }
            state.conformiteForm.folderNumberLong = rootState.refProperties.property.folderNumberLong;
            formData.append('data', JSON.stringify(state.conformiteForm));
            dispatch('postFormRoute', { endpoint, form: formData });
        },
        handleSubmit({ dispatch }) {
            dispatch('submitConformite', { action: `create` });
        },
        handleSubmitEdit({ dispatch }) {
            dispatch('submitConformite', { action: `edit` });
        },

        initConformiteForm({ commit }) {
            commit('initFormConformite');
        },
    },
    mutations: {
        setConformiteForm(state, payload) {
            let equipments = [];

            Object.entries(payload).map(([key, val]) => {
                if (val && typeof val === 'object' && val.constructor === Object) {
                    if (typeof val.id !== 'undefined') {
                        payload[key] = val.id;
                    }
                }
            });
            if (payload.equipementsPretraitementSelection) {
                equipments = payload.equipementsPretraitementSelection.map(value => value.id);
                payload.equipementsPretraitementSelection = equipments;
            }

            state.conformiteForm = payload;
        },
        initFormConformite(state) {
            state.conformiteForm = { ...conformiteFields, ...attachmentFields };
        },
        addExtratFieldsToFormConformite(state, payload) {
            state.conformiteForm.property = payload.property;
            state.conformiteForm.user = null;
        },
        setPreTreatmentEquipments(state, payload) {
            state.preTreatmentEquipments = payload;
        },
        setStormWaterStructure(state, payload) {
            state.stormWaterStructure = payload;
        },
    },
};
